import classNames from "classnames";
import React, { ButtonHTMLAttributes, PropsWithChildren } from "react";

type ButtonProps = {
  href?: string;
  target?: string;
  isPrimary?: boolean;
  download?: boolean;
  isSmall?: boolean;
} & PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>;

export const Button = ({
  children,
  className,
  href,
  target,
  isPrimary,
  download,
  isSmall,
  ...props
}: ButtonProps) => {
  if (!!href) {
    return (
      <a
        href={href}
        target={target}
        download={download}
        className={classNames(
          "rounded-[10px] px-[20px] py-[12px] text-sm font-medium flex items-center justify-center",
          {
            "bg-success text-white": isPrimary,
            "bg-white border border-[#E4E4E4]": !isPrimary,
            "h-[46px]": !isSmall,
            "h-[38px]": isSmall,
          },
          className
        )}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      className={classNames(
        "font-bold rounded-[10px] px-[20px] py-[12px] text-sm flex items-center justify-center",
        {
          "bg-success text-white": isPrimary,
          "bg-white border border-[#E4E4E4]": !isPrimary,
          "h-[46px]": !isSmall,
          "h-[38px]": isSmall,
        },
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};
